import React from 'react';
import withIcon from '../utilities/withIcon';

const IconShare = () => {
  return (
    <g>
      <path d="m1.05 1.97 5.925.008a.751.751 0 0 1 .1 1.497l-.102.007-5.474-.009v10.023h9.992v-2.483c0-.38.282-.695.648-.745l.102-.006a.75.75 0 0 1 .742.65l.007.101v2.934c0 .543-.41.99-.935 1.047l-.114.006H1.049c-.54 0-.986-.41-1.043-.938L0 13.947V3.022c0-.543.41-.99.935-1.047l.116-.006zm11.408-.809.082.075 3.256 3.47c.245.26.27.652.074.94l-.074.09-3.253 3.466a.748.748 0 0 1-1.059.032.754.754 0 0 1-.102-.976l.07-.086 2.062-2.199h-5.52A3.252 3.252 0 0 0 4.75 9.046l-.005.185v1.788a.75.75 0 0 1-1.492.102l-.006-.102V9.231a4.755 4.755 0 0 1 4.529-4.757l.217-.005h5.522l-2.067-2.202a.754.754 0 0 1-.044-.98l.075-.083a.748.748 0 0 1 .978-.043z" />
    </g>
  );
};

export default withIcon(IconShare);
